// Export the Toast component
export {Toast} from './Toast';
export {
  ToastContextProvider,
  useToastContext,
  ToastStylesProvider,
  useToastStyles,
  getStatusIcon,
  type ToastContext,
} from './context';
import {useToast as useChakraToast} from '@chakra-ui/react';

/** @deprecated Use `toast` from `@lib/components/ui/toast` instead */
export const useToast = useChakraToast;
export type {UseToastOptions, ToastProps as ChakraToastProps} from '@chakra-ui/react';
export type {ToastProps} from './types';
